<template>
  <div class="premium-content">
    <div class="premium-header">
      <div class="title">
        <div class="prev-icon-and-name">
          <i v-if="premium.iconClass" class="icon" :class="premium.iconClass"></i>
          <span class="name">{{ premium.name }}</span>
        </div>
        <el-tooltip
          v-if="premium.hasToolTip"
          effect="light"
          popper-class="light-tooltip-popper"
          :content="$t(premium.tooltipContentKey)"
        >
          <i class="tooltip-icon el-icon-question"></i>
        </el-tooltip>
      </div>
      <el-switch
        v-if="premium.elType === 'switch'"
        v-model="premium.isEnabled"
        class="premium-switch"
      ></el-switch>
      <el-input v-else-if="premium.elType === 'input'" v-model="premium.value" class="premium-input"></el-input>
      <slot v-else-if="premium.headerSlot" :name="premium.headerSlot" :premiumDetail="premium"></slot>
      <component
        v-else
        :is="premium.elType"
        v-bind="premium"
        :props="premium.props"
      ></component>
      <div class="expire-date">
        <el-date-picker
          v-model="premium.expire_date"
          type="date"
          value-format="yyyy-MM-dd"
          :placeholder="$t('admin.company.companyApprovalManagement.placeholder.selectDate')"
          :disabled="!premium.isEnabled"
          @change="handlePremiumChange"
        >
        </el-date-picker>
      </div>
    </div>
    <div v-if="premium.detailSlot" class="premium-detail-content">
      <slot :name="premium.detailSlot" :premiumDetail="premium"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    premium: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    handlePremiumChange () {
      this.$emit('change', this.premium)
    }
  }
}
</script>

<style lang="scss" scoped>
.premium-content {
  .premium-header {
    display: flex;
    align-items: center;
    .title {
      display: flex;
      align-items: center;
      width: 240px;
      max-width: 240px;
      margin-right: 20px;
      .prev-icon-and-name {
        display: inline-block;
        vertical-align: middle;
        .icon {
          font-size: 22px;
          color: #0096cc;
          vertical-align: middle;
          margin-right: 6px;
        }
        .name {
          font-size: 14px;
          color: #303133;
          font-weight: 500;
          margin-right: 20px;
          vertical-align: middle;
        }
      }
      .tooltip-icon {
        font-size: 16px;
        color: #0096cc;
        vertical-align: middle;
      }
    }
    .premium-input {
      width: 100px;
    }
    .expire-date {
      right: 60px;
      position: absolute;
    }
  }
  .premium-detail-content {
    color: #606266;
    font-size: 14px;
    margin-left: 22px;
  }
}
</style>
